import { Box, Button, Stack, Typography, useTheme } from '@mui/material'
import { FC } from 'react'
import BellIcon from '../../assets/icons/Bell.svg'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'

type Props = {
    open: boolean
    onClose: VoidFunction
}

export const WebPushPermissionDeniedDialog: FC<Props> = ({ open, onClose }) => {
    const { breakpoints } = useTheme()

    return (
        <ModalDialogWrapper
            open={open}
            handleClose={onClose}
            title={
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '100px',
                        padding: '10px',
                        backgroundColor: '#006CFD',
                        color: '#FFFFFF',
                    }}>
                    <BellIcon />
                </Box>
            }
            sx={{
                '.MuiPaper-root': {
                    width: '390px',
                    maxWidth: '390px',

                    [breakpoints.down('sm')]: {
                        width: '100%',
                        maxWidth: '100%',
                    },
                },
            }}
            footerActions={
                <Stack
                    sx={{
                        width: '100%',
                        flexDirection: 'row',
                    }}>
                    <Button
                        variant="contained"
                        onClick={onClose}
                        sx={{
                            width: '100%',
                        }}>
                        Понятно
                    </Button>
                </Stack>
            }>
            <Stack
                direction="column"
                gap={1}
                sx={{
                    maxWidth: '330px',
                    [breakpoints.down('sm')]: {
                        maxWidth: 'unset',
                    },
                }}>
                <Typography variant="h4">Уведомления запрещены в браузере</Typography>
                <Typography variant="caption2" color="#5A5F72">
                    Чтобы мы могли сообщать о выполненных задачах, изменениях в аккаунте и новостях
                    сервиса, пожалуйста, разрешите отправку уведомлений в браузере
                </Typography>
            </Stack>
        </ModalDialogWrapper>
    )
}
